import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { FeaturesEnum, PermissionTypesEnum } from '@api/ringil-api.v2';
import { AuthenticatedUserContext } from '@components/auth/AuthenticatedUser.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import useNavigation from '@hooks/useNavigation';
import { isNullOrUndefined } from '@utils/utils';
import CompanyEmailHistory from '@components/RingilComponents/emailHistory/CompanyEmailHistory.tsx';

const EmailHistoryPage: React.FC = () => {
  const { tr } = useTranslationLgs();
  const nav = useNavigation();
  const { loggedUser, hasFeature } = useContext(AuthenticatedUserContext);

  if (isNullOrUndefined(loggedUser)) return <>Loading...</>;
  // Without the feature the page does not exist for this company, so it redirects rather than
  // reporting a permission the user may well hold.
  if (!hasFeature([FeaturesEnum.ENABLE_SENDER_EMAIL_HISTORY])) return <Navigate to={nav.createNavigationLink(nav.urlFunctions.createHomePage())} replace />;

  return (
    <ResponsiveLayout
      title={tr('EmailHistory.pageTitle', 'Communication history')}
      oneOfPermission={[PermissionTypesEnum.PERMISSION_EMAIL_HISTORY_READ, PermissionTypesEnum.PERMISSION_EMAIL_HISTORY_RW]}>
      <CompanyEmailHistory />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(EmailHistoryPage);
